import React from 'react';
import PropTypes from 'prop-types';

import TableRow from './table_row';
import { reorderableList } from 'helpers/react_dnd/reorderable_list';

export class ReorderableTable extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    itemClassName: PropTypes.string,
    tableClassName: PropTypes.string,
    onReorder: PropTypes.func.isRequired,
  };

  render() {
    return (
      <table className={this.props.tableClassName}>
        <tbody>
          {this.renderRows()}
        </tbody>
      </table>
    );
  }

  renderRows() {
    return this.props.children.map((Child, i) => {
      return (
        <TableRow
          className={this.props.itemClassName}
          index={i}
          key={i}
          listName="filterTable"
          onReorder={this.props.onReorder}
        >
          {Child}
        </TableRow>
      );
    });
  }
}

export default reorderableList(ReorderableTable);
